// extracted by mini-css-extract-plugin
export var limitWidthOnLargeScreens = "TabsV3-module--limitWidthOnLargeScreens--4lnKb";
export var selectedTab = "TabsV3-module--selectedTab--H307F";
export var tab = "TabsV3-module--tab--nOcms";
export var tabsContainer = "TabsV3-module--tabsContainer--4kp3Q";